import { Component } from '@opten/compiler/metadata/component';
import debounce from '@opten/reactive/debounce';

@Component({ className: 'js-center-image' })
export class CenterImageComponent {
	constructor(private element: HTMLElement) {
		const sourceLink = element.getAttribute('data-background-source');
		const currentWidth = element.clientWidth;
		const currentHeight = element.clientHeight;

		element.style.backgroundImage = 'url("' + sourceLink + '&height=' + currentHeight + '&width=' + currentWidth + '")';

		window.addEventListener("resize", debounce(() => {
			const currentWidth = element.clientWidth;
			const currentHeight = element.clientHeight;

			element.style.backgroundImage = `url('${sourceLink}&height=${currentHeight}&width=${currentWidth}')`;
		}, 200));
	}
}